import React, { Component } from 'react';
import { Layout, Menu, Icon } from 'antd';

import IconSvg from '../../../utils/svg';

import './sidemenu.css';

const { Sider } = Layout;
const { Item, SubMenu } = Menu;

class SideMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            width: window.innerWidth,
        }
        this.createMenu = this.createMenu.bind(this);
    }

    createMenu(array) {
        return array.map((e,i) => {
            if(!e.subItems || e.subItems.length === 0 ) {
                return (
                    <Item key={ i } onClick={ e.click }>
                        <Icon type={ e.icon }/>
                        <span>{ e.text }</span>
                    </Item>
                );
            } else {
                return (
                    <SubMenu key={ i } 
                        title={
                            <span><Icon type={ e.icon } /><span>{ e.text }</span></span>}>
                        { e.subItems.map( (el, i) => <Item onClick={ e.click } key={`${i}_${e.text}`}>{el.text}</Item> )}
                    </SubMenu>
                );
            }
        });
    }

    handleWindowResize = ({currentTarget}) => {
        this.setState({ width: currentTarget.innerWidth });
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleWindowResize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleWindowResize);
    }

    render() {
        const { width } = this.state;
        const { collapsed, className, theme, children, items } = this.props;

        return (
            ((width <= 768 && collapsed === false) || width >= 768) &&
                <Sider className={`sidemenu ${ className ? className:''}`} trigger={ null} collapsible collapsed={ collapsed }>
                    <div className="sideMenu-logo">
                        <IconSvg name='icon-febracis' width='35px' />
                    </div>
                    { !children &&
                    <Menu theme={ theme? theme: 'dark'} mode="inline" defaultSelectedKeys={['0']}>
                        { items && this.createMenu(items)}
                    </Menu>
                    }
                    { children }
                </Sider>
        

        );
    }
}

export default SideMenu;


// WEBPACK FOOTER //
// ./src/App/components/sidemenu/sidemenu.js